import { PushNotificationsModule } from 'ng-push';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { ClientComponent } from './client/client.component';
import { VendorComponent } from './vendor/vendor.component';
import { PartsComponent } from './parts/parts.component';
import { MyContractsComponent } from './client/my-contracts/my-contracts.component';
import { MyForecastComponent } from './client/my-forecast/my-forecast.component';
import { MySupportComponent } from './client/my-support/my-support.component';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from '../app-routing.module';
import { PagesComponent } from './pages.component';
import { MatSidenavModule, MatMenuModule } from '@angular/material';
import { DataTableModule } from 'angular2-datatable';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { DocumentationModule } from './documentation/documentation.module';
import { ContractComponent } from './client/my-contracts/contract/contract.component';
import { BsDropdownModule } from 'ngx-bootstrap';
import { MySettingsComponent } from './client/my-settings/my-settings.component';
import { ChangePasswordComponent } from './client/my-settings/change-password/change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddcontractComponent } from './client/my-contracts/contract/addcontract/addcontract.component';
/* import { BankAccountsComponent } from './client/my-settings/bank-accounts/bank-accounts.component';
import { AddBankAccountComponent } from './client/my-settings/bank-accounts/add-bank-account/add-bank-account.component';
import { UpdateBankAccountComponent } from './client/my-settings/bank-accounts/update-bank-account/update-bank-account.component'; */
import { BankAccountModule } from './client/my-settings/bank-accounts/bank-accounts.module';
import { LoginComponent } from './account/login/login.component';
import { NgProgressModule } from '@ngx-progressbar/core';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { ChangepwdComponent } from './account/changepwd/changepwd.component';
import { UpdateRegistrationComponent } from './client/my-contracts/contract/update-registration/update-registration.component';
import { ClientRegisterComponent } from './account/client-register/client-register.component';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { PipesModule } from './../pipes/pipes.module';
import { PreChatComponent } from './account/pre-chat/pre-chat.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { PostedinvoicesComponent } from './client/my-contracts/postedinvoices/postedinvoices.component';
import { MySettingsVComponent } from './vendor/my-settings-v/my-settings-v.component';
import { MyProfileVComponent } from './vendor/my-settings-v/my-profile-v/my-profile-v.component';
import { ChangePasswordVComponent } from './vendor/my-settings-v/change-password-v/change-password-v.component';
import { ManageUsersVComponent } from './vendor/my-settings-v/manage-users-v/manage-users-v.component';
import { MyVendorComponent } from './vendor/my-vendor/my-vendor.component';
import { VendorHomeComponent } from './vendor/my-vendor/vendor-home/vendor-home.component';
import { PurchaseOrderViewComponent } from './vendor/my-vendor/purchase-order-view/purchase-order-view.component';
import { InvoicesViewComponent } from './vendor/my-vendor/invoices-view/invoices-view.component';
import { PaymentsViewComponent } from './vendor/my-vendor/payments-view/payments-view.component';
import { BankAccountVComponent } from './vendor/my-settings-v/bank-account-v/bank-account-v.component';
import { VendorRegisterComponent } from './account/vendor-register/vendor-register.component';
import { VendorSupportComponent } from './vendor/my-vendor/vendor-support/vendor-support.component';
import { SearchContractsComponent } from './client/my-contracts/search-contracts/search-contracts.component';
import { MarketPlaceComponent } from './client/market-place/market-place.component';
import { NguCarouselModule } from '@ngu/carousel';
import { VendorContactComponent } from './vendor/my-vendor/vendor-contact/vendor-contact.component';
import { VendorContactModule } from './vendor/my-vendor/vendor-contact/vendor-contact.module';
import { ForgotPasswordComponent } from './account/forgot-password/forgot-password.component';
import { PoDetailComponent } from './vendor/my-vendor/purchase-order-view/po-detail/po-detail.component';
import { PaymentDetailsVComponent } from './vendor/my-vendor/payments-view/payment-details-v/payment-details-v.component';
import { InvoiceDetailsComponent } from './vendor/my-vendor/invoices-view/invoice-details/invoice-details.component';
import { VendorStatementComponent } from './vendor/my-vendor/vendor-statement/vendor-statement.component';
import { TaxFormsComponent } from './vendor/my-settings-v/tax-forms/tax-forms.component';
import { SubmitVendorInvoiceComponent } from './vendor/my-vendor/invoices-view/submit-vendor-invoice/submit-vendor-invoice.component';
import { CoverageSearchComponent } from './vendor/my-vendor/coverage-search/coverage-search.component';
import { W9FormComponent } from './vendor/my-settings-v/tax-forms/w9-form/w9-form.component';
import { AccordionModule as BootstrapAccordionModule } from 'ngx-bootstrap';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { VendorSetupComponent } from './vendor-setup/vendor-setup.component';
import { NewVendorComponent } from './vendor-setup/new-vendor/new-vendor.component';
import { DomesticVendorFormComponent } from './vendor-setup/domestic-vendor-form/domestic-vendor-form.component';
import { InternationalVendorFormComponent } from './vendor-setup/international-vendor-form/international-vendor-form.component';
import { RemitToComponent } from './vendor/my-settings-v/remit-to/remit-to.component';
import { Forms1099Component } from './vendor/my-settings-v/tax-forms/1099-forms/1099-forms.component';
import { CompanyComponent } from './vendor/my-settings-v/company/company.component';
import { PastdueinvoicesComponent } from './client/my-contracts/pastdueinvoices/pastdueinvoices.component';
import { EnvironmentComponent } from './environment/environment.component';
import { Co2OffsetComponent } from './client/co2-offset/co2-offset.component';
import { MyjssiBundleComponent } from './myjssi-bundle/myjssi-bundle.component';
import { UniversalloginComponent } from './account/login/universallogin/universallogin.component';
import { TransientComponent } from './account/transient/transient.component';
import { MarketingComponent } from './client/marketing/marketing.component';
import { MarketingInfoComponent } from './marketing-info/marketing-info.component';
import { AdvisoryservicesComponent } from './advisoryservices/advisoryservices.component';
import { PowerBireportComponent } from '../shared-components/power-bireport/power-bireport.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    ReCaptchaModule,
    SharedComponentsModule,
    BrowserModule,
    PipesModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    RouterModule,
    DocumentationModule,
    AngularFontAwesomeModule,
    AppRoutingModule,
    MatSidenavModule,
    ReactiveFormsModule,
    MatMenuModule,
    DataTableModule,
    BsDropdownModule.forRoot(),
    PushNotificationsModule,
    NgProgressModule.forRoot(),
    FormsModule,
    BankAccountModule,
    HttpModule,
    NgxPaginationModule,
    NguCarouselModule,
    VendorContactModule,
    BootstrapAccordionModule.forRoot(),
    MatNativeDateModule,
    MatDatepickerModule
  ],
  declarations: [
    ClientComponent,
    VendorComponent,
    PartsComponent,
    MyContractsComponent,
    MyForecastComponent,
    MySupportComponent,
    ContractComponent,
    PagesComponent,
    MySettingsComponent,
    LoginComponent,
    AddcontractComponent,
    ResetPasswordComponent,
    UpdateRegistrationComponent,
    ChangepwdComponent,
    ClientRegisterComponent,
    PreChatComponent,
    PostedinvoicesComponent,
    MySettingsVComponent,
    MyProfileVComponent,
    ChangePasswordVComponent,
    MyVendorComponent,
    VendorHomeComponent,
    PurchaseOrderViewComponent,
    InvoicesViewComponent,
    PaymentsViewComponent,
    BankAccountVComponent,
    VendorRegisterComponent,
    VendorSupportComponent,
    SearchContractsComponent,
    MarketPlaceComponent,
    ForgotPasswordComponent
    , PoDetailComponent
    , PaymentDetailsVComponent, InvoiceDetailsComponent
    , SubmitVendorInvoiceComponent
    , VendorStatementComponent,
    TaxFormsComponent,
    CoverageSearchComponent,
    W9FormComponent,
    VendorSetupComponent,
    NewVendorComponent,
    DomesticVendorFormComponent,
    InternationalVendorFormComponent,
    RemitToComponent,
    Forms1099Component,
    CompanyComponent,
    PastdueinvoicesComponent,
    EnvironmentComponent,
    Co2OffsetComponent,
    MyjssiBundleComponent,
    UniversalloginComponent,
    TransientComponent,
    MarketingComponent,
    MarketingInfoComponent,
    AdvisoryservicesComponent
    
  ],
  exports: [
    AddcontractComponent,
    MatDatepickerModule
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts